"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Modal_1 = tslib_1.__importStar(require("./Modal"));
var show_1 = require("../../utils/show");
var helper_1 = require("../../utils/helper");
exports.default = helper_1.wrapWithConfigDefaults(function (config) {
    config.onClose = config.onClose || config.onCancel;
    return show_1.showWithTransition({
        Component: Modal_1.default,
        transitionDuration: Modal_1.MODAL_TRANSITION_OUT_DURATION,
        autoClose: false,
        props: config,
        forcedProps: { destroyOnClose: true },
        injectClosePropNames: ['onOk', 'onCancel', 'onClickAction', 'onClose'],
        contexts: config.contexts,
    });
});
